import { useWidgetConfig } from '@/context/WidgetConfigContext';
import { TITLE_OPTIONS } from '@/helpers/constants/registration';
import { COLORS } from '@/helpers/constants/theme';
import { useHoverBackground } from '@/hooks/useHoverBackground';
import { E_CustomerTitle } from '@/types/Shopify';
import type { T_TitleProps } from '@/types/Title';

export const Title = ({ title, setTitle, error }: T_TitleProps) => {
  const { theme } = useWidgetConfig();

  const { backgroundColor = COLORS.BRAND_SECONDARY, textColor = COLORS.TEXT_INVERSE } =
    theme?.secondaryButton ?? {};

  const { backgroundColor: hoverBackground, hoverHandlers } = useHoverBackground({
    baseColor: backgroundColor,
  });
  return (
    <div className='space-y-2 py-2'>
      <div className='flex gap-4'>
        {Object.values(E_CustomerTitle).map((value) => {
          const isSelected = title === value;
          const Icon = TITLE_OPTIONS[value];
          const iconColor = isSelected ? textColor : theme?.bodyColor;

          return (
            <label key={value} className='cursor-pointer'>
              <input
                type='radio'
                name='title'
                value={value}
                checked={isSelected}
                onChange={() => setTitle(value)}
                className='hidden'
              />

              <div
                {...hoverHandlers}
                className={`secondary-button flex items-center gap-2 rounded-md px-4 py-2 text-sm transition-all duration-200 ${
                  isSelected ? '' : 'border border-transparent'
                } ${error ? 'border-red-600' : ''}`}
                style={{
                  backgroundColor: isSelected ? hoverBackground : undefined,
                  color: isSelected ? textColor : undefined,
                }}
              >
                <Icon className='h-5 w-5 flex-shrink-0' color={iconColor} />
                <span
                  style={{
                    color: isSelected ? textColor : undefined,
                  }}
                >
                  {value}
                </span>
              </div>
            </label>
          );
        })}
      </div>

      {error && <h6 className='!text-red-600'>{error}</h6>}
    </div>
  );
};
